import React from 'react';
import Lottie from 'lottie-react';

import Button from '../../../common/Button/Button';
import FormContainer from '../../../common/FormContainer/FormContainer';
import { Alert, Box } from '@mui/material';

import successAnimation from '../../../../assets/lottie/success.json';
import './SubmissionCompleted.css';

export function SubmissionCompleted({
  mode = 'submission_successful',
  submissionData,
  isLoading = false,
  onNewSubmission
}) {
  const isAlreadySubmitted = mode === 'already_submitted';

  const title = isAlreadySubmitted
    ? 'Submission Already Received!'
    : 'Submission Successful!';

  const message = isAlreadySubmitted
    ? 'You have already submitted your idea. Thank you for your contribution!'
    : 'Your idea has been successfully submitted. Thank you for your contribution!';

  return (
    <div className="submission-completed">
      <FormContainer>
        <div className="success-message-container">

          {/* ===== LOTTIE SUCCESS ANIMATION ===== */}
          <div className="success-lottie">
            <Lottie
              animationData={successAnimation}
              autoplay
              loop={false}
              style={{ width: 150, height: 150 }}
            />
          </div>

          <h2 className="success-title">{title}</h2>

          <p className="success-message">{message}</p>

       {/* ===== SELECTION INFO ===== */}


          {/* ===== Submission Summary ===== */}
          {submissionData && (
            <div className="submission-summary">
              <h3>Your Submission</h3>

              <div className="summary-item">
                <strong>Theme:</strong>{' '}
                {submissionData.theme?.customTheme ||
                  submissionData.theme?.themeTitle}
              </div>

              {submissionData.submitDetails?.name && (
                <div className="summary-item">
                  <strong>Name:</strong>{' '}
                  {submissionData.submitDetails.name}
                </div>
              )}

              {submissionData.submittedAt && (
                <div className="summary-item">
                  <strong>Submitted on:</strong>{' '}
                  {new Date(submissionData.submittedAt).toLocaleDateString(
                    'en-IN',
                    {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    }
                  )}
                </div>
              )}
            </div>
          )}
<Box mt={2}>
  <Alert
    severity="info"
    variant="outlined"
    sx={{ textAlign: 'left' }}
  >
    Submissions will be evaluated as part of the selection process, and shortlisted participants will be notified.
  </Alert>
</Box>

          {/* ===== Actions ===== */}
          {onNewSubmission && (
            <div className="submission-actions">
              <Button
                size="large"
                onClick={onNewSubmission}
                disabled={isLoading}
              >
                {isLoading ? 'Loading...' : 'Submit Another Idea'}
              </Button>
            </div>
          )}

          
        </div>
      </FormContainer>
    </div>
  );
}
